var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperFoodInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.376,112.45A14.029,14.029,0,1,1,317.4,98.421,14.045,14.045,0,0,1,303.376,112.45Zm0-27a12.971,12.971,0,1,0,12.972,12.971A12.986,12.986,0,0,0,303.376,85.45Z",
    transform: "translate(-286.376 -81.421)",
    fill: "#635c7c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.858 9.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.636,11.457a.757.757,0,0,1,0-1.5H1.3A8.651,8.651,0,0,1,3.49,4.8,7.311,7.311,0,0,1,8.225,2.4a.094.094,0,0,0,0-.011c0-.006,0-.012,0-.018V1.478H7.862A.751.751,0,0,1,7.226.7.671.671,0,0,1,7.862,0h2.32a.671.671,0,0,1,.637.7.751.751,0,0,1-.637.778H9.546v.894c0,.007,0,.013,0,.019V2.4a7.547,7.547,0,0,1,4.807,2.4A8.506,8.506,0,0,1,16.61,9.962h.573a.663.663,0,0,1,.637.685c0,.375-.278.81-.637.81Zm2.007-1.5H15.1A6.323,6.323,0,0,0,8.91,3.915,6.36,6.36,0,0,0,2.643,9.962Zm1.33-1.131c-.036-.387-.1-.353-.015-.575A6.115,6.115,0,0,1,6.366,5.308c.3-.191.288-.243.549-.077.3.192.072.752-.232.942A4.764,4.764,0,0,0,4.808,8.467a.637.637,0,0,1-.586.42c-.038,0-.091.008-.138.008S3.978,8.883,3.973,8.831Z",
    fill: "#635c7c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperFoodInactiveIcon);
export default __webpack_public_path__ + "static/media/swiper_food_inactive_icon.bf82fd56.svg";
export { ForwardRef as ReactComponent };